import { Box, Typography } from '@mui/material'

export const InfoRow: React.FC<{
  label: string
  value: string | null | undefined
}> = ({ label, value }) => {
  return (
    <Box display='flex' margin={1}>
      <Typography fontWeight='bold'>{label}:&nbsp;</Typography>
      <Typography>{value}</Typography>
    </Box>
  )
}
